const TotalsSection = ({
  hasTitels, titelGroups, subtotal, discount, setDiscount, discountType,
  discountAmt, netAfterDiscount, vatRate, setVatRate, vat, total,
  type, depositAmount, setDepositAmount, finalAmount, depositLocked,
  dueDays, setDueDays, createdAt,
  showLohnanteil, setShowLohnanteil, effectiveLohnanteil, lohnanteilMwst, lohnanteilBrutto, lohnanteilCustom, setLohnanteilCustom, totalLaborCost,
}) => {
  // Anzeigename fuer interne Gruppe "__ungrouped" -> "Allgemeine Positionen"
  const displayTitel = (t) => (t === "__ungrouped" ? "Allgemeine Positionen" : t);
  // Vorschau-Datum aus dueDays + createdAt (oder heute)
  const dueDateLabel = (() => {
    if (type !== "invoice" || dueDays == null) return "";
    try {
      const base = createdAt ? new Date(createdAt) : new Date();
      const d = new Date(base.getTime() + Number(dueDays) * 86400000);
      return d.toLocaleDateString("de-DE");
    } catch { return ""; }
  })();
  return (
    <div className="px-4 lg:px-10 py-4 lg:py-6 border-t">
      {/* Desktop Totals */}
      <table className="hidden lg:table w-full">
        <tbody>
          {/* Gewerk-/Titelzusammenstellung (nur wenn Titel vorhanden) */}
          {hasTitels && titelGroups.length > 0 && (
            <>
              <tr>
                <td className="w-8"></td>
                <td style={{ width: "35px" }}></td>
                <td colSpan={4} className="py-3 text-sm font-bold text-primary">Gewerk-/Titelzusammenstellung</td>
                <td style={{ width: "75px" }}></td>
                <td className="w-8"></td>
              </tr>
              {titelGroups.map((g, i) => (
                <tr key={`tg-${i}`} className="border-b border-slate-100">
                  <td className="w-8"></td>
                  <td style={{ width: "35px" }}></td>
                  <td colSpan={4} className="py-2 text-sm">
                    {g.nr && <span className="font-semibold mr-2">{g.nr}</span>}
                    {displayTitel(g.titel)}
                  </td>
                  <td className="text-right py-2 font-mono text-sm" style={{ width: "75px" }}>{g.sum.toFixed(2)} €</td>
                  <td className="w-8"></td>
                </tr>
              ))}
              <tr className="border-t border-slate-300">
                <td className="w-8"></td>
                <td style={{ width: "35px" }}></td>
                <td colSpan={3}></td>
                <td style={{ width: "45px" }}></td>
                <td style={{ width: "45px" }}></td>
                <td className="w-8"></td>
              </tr>
            </>
          )}
          {/* Nettosumme */}
          <tr>
            <td className="w-8"></td>
            <td style={{ width: "35px" }}></td>
            <td></td>
            <td style={{ width: "45px" }}></td>
            <td style={{ width: "45px" }}></td>
            <td className="text-right py-2 text-muted-foreground text-sm" style={{ width: "70px" }}>Nettosumme</td>
            <td className="text-right py-2 font-mono text-sm" style={{ width: "75px" }}>{subtotal.toFixed(2)} €</td>
            <td className="w-8"></td>
          </tr>
          {/* Zu-/Abschlag */}
          <tr>
            <td></td><td></td><td></td><td></td><td></td>
            <td className="text-right py-2 text-sm" style={{ width: "70px" }}>
              <div className="flex items-center justify-end gap-1">
                <span className="text-muted-foreground text-xs">Abschlag</span>
                <input type="number" step="0.1" value={discount || ""}
                  onChange={(e) => setDiscount(parseFloat(e.target.value) || 0)}
                  placeholder="0"
                  className="w-14 h-6 text-xs border rounded px-1 bg-white text-right font-mono"
                  data-testid="discount-input"
                />
                <span className="text-xs text-muted-foreground">%</span>
              </div>
            </td>
            <td className="text-right py-2 font-mono text-sm" style={{ width: "75px" }}>
              {discountAmt > 0 ? `-${discountAmt.toFixed(2)} €` : "0,00 €"}
            </td>
            <td></td>
          </tr>
          {/* Nettobetrag nach Abschlag */}
          {discount > 0 && (
            <tr className="border-t border-slate-200">
              <td></td><td></td><td></td><td></td><td></td>
              <td className="text-right py-2 text-sm font-medium" style={{ width: "84px" }}>Nettobetrag</td>
              <td className="text-right py-2 font-mono text-sm font-medium" style={{ width: "105px" }}>{netAfterDiscount.toFixed(2)} €</td>
              <td></td>
            </tr>
          )}
          {/* MwSt */}
          <tr>
            <td></td><td></td><td></td><td></td><td></td>
            <td className="text-right py-2 text-sm" style={{ width: "84px" }}>
              <div className="flex items-center justify-end gap-1">
                <span className="text-muted-foreground">MwSt</span>
                <select value={vatRate} onChange={(e) => setVatRate(parseFloat(e.target.value))}
                  className="h-6 text-xs border rounded px-1 bg-white">
                  <option value={19}>19%</option>
                  <option value={7}>7%</option>
                  <option value={0}>0%</option>
                </select>
              </div>
            </td>
            <td className="text-right py-2 font-mono text-sm" style={{ width: "105px" }}>{vat.toFixed(2)} €</td>
            <td></td>
          </tr>
          {/* Brutto / Gesamt — schwarze Linie wie PDF, leicht eingerückt */}
          <tr className="border-t-2 border-slate-900">
            <td></td><td></td><td></td><td></td><td></td>
            <td className="text-right py-3 font-bold text-base" style={{ width: "84px" }}>Brutto</td>
            <td className="text-right py-3 font-mono font-bold text-base" style={{ width: "105px" }}>{total.toFixed(2)} €</td>
            <td></td>
          </tr>
          {/* Anzahlung (05.10.2026): in der AB die vereinbarte Anzahlung, Vorschlag 30 % */}
          {type === "order" && (
            <tr>
              <td></td><td></td><td></td><td></td><td></td>
              <td className="text-right py-2 text-muted-foreground text-sm">Anzahlung</td>
              <td className="text-right py-2">
                <div className="flex items-center justify-end">
                  <input type="number" step="0.01" min="0" value={depositAmount ?? ""}
                    onChange={(e) => setDepositAmount(parseFloat(e.target.value) || 0)}
                    className="w-20 border rounded px-2 py-1 text-sm text-right font-mono" data-testid="input-order-deposit" />
                  <span className="ml-1 text-sm">€</span>
                </div>
              </td>
              <td>
                <button type="button" onClick={() => setDepositAmount(Math.round(total * 30) / 100)}
                  className="ml-1 whitespace-nowrap text-[10px] px-1.5 py-0.5 border rounded text-muted-foreground hover:bg-muted"
                  title="30 % des Auftragswerts eintragen" data-testid="btn-order-deposit-30">30 %</button>
              </td>
            </tr>
          )}
          {type === "invoice" && (
            <>
              <tr>
                <td></td><td></td><td></td><td></td><td></td>
                <td className="text-right py-2 text-muted-foreground text-sm">Anzahlung</td>
                <td className="text-right py-2">
                  <div className="flex items-center justify-end">
                    <input type="number" step="0.01" value={depositAmount} readOnly={depositLocked}
                      title={depositLocked ? "Summe der Anzahlungsrechnungen – wird automatisch abgezogen" : undefined}
                      onChange={(e) => setDepositAmount(parseFloat(e.target.value) || 0)}
                      className={`w-20 border rounded px-2 py-1 text-sm text-right font-mono ${depositLocked ? "bg-muted" : ""}`} />
                    <span className="ml-1 text-sm">€</span>
                  </div>
                </td>
                <td></td>
              </tr>
              {setDueDays && (
                <tr>
                  <td></td><td></td><td></td>
                  <td colSpan={2} className="text-right py-2 text-xs text-muted-foreground">
                    {dueDateLabel && <>Zahlbar bis <strong>{dueDateLabel}</strong></>}
                  </td>
                  <td className="text-right py-2 text-muted-foreground text-sm">Zahlungsziel</td>
                  <td className="text-right py-2">
                    <div className="flex items-center justify-end">
                      <input type="number" min="0" step="1"
                        value={dueDays ?? ""}
                        onChange={(e) => setDueDays(e.target.value === "" ? null : Math.max(0, parseInt(e.target.value, 10) || 0))}
                        className="w-16 border rounded px-2 py-1 text-sm text-right font-mono"
                        data-testid="input-invoice-due-days" />
                      <span className="ml-1 text-sm">Tage</span>
                    </div>
                  </td>
                  <td></td>
                </tr>
              )}
              {depositAmount > 0 && (
                <tr>
                  <td></td><td></td><td></td><td></td><td></td>
                  <td className="text-right py-2 text-primary font-semibold text-sm">Restbetrag</td>
                  <td className="text-right py-2 font-mono text-primary font-semibold text-sm">{finalAmount.toFixed(2)} €</td>
                  <td></td>
                </tr>
              )}
            </>
          )}
          {/* Lohnanteil (nur Rechnung) */}
          {type === "invoice" && (
          <tr>
            <td></td><td></td><td></td><td></td><td></td>
            <td colSpan={2} className="pt-4 pb-2">
              <div className="border-t pt-3">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium">Lohnanteil</span>
                  <button type="button" onClick={() => setShowLohnanteil(!showLohnanteil)}
                    className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${showLohnanteil ? "bg-green-100 text-green-700" : "bg-muted text-muted-foreground"}`}
                    data-testid="btn-toggle-lohnanteil">
                    {showLohnanteil ? "Wird ausgewiesen" : "Nicht ausweisen"}
                  </button>
                </div>
                <div className="space-y-1 text-sm">
                  <div className="flex justify-between items-center">
                    <span className="text-muted-foreground">Lohnanteil (netto)</span>
                    <div className="flex items-center gap-1">
                      <input type="number" step="0.01" value={lohnanteilCustom}
                        onChange={(e) => setLohnanteilCustom(e.target.value)}
                        placeholder={totalLaborCost > 0 ? `Automatik ${Number(totalLaborCost).toFixed(2)}` : "0.00"}
                        className="w-28 border rounded px-2 py-1 text-right font-mono text-sm" data-testid="input-lohnanteil" />
                      <span className="text-muted-foreground">€</span>
                    </div>
                  </div>
                  {effectiveLohnanteil > 0 && (
                    <>
                      <div className="flex justify-between text-muted-foreground">
                        <span>zzgl. {vatRate}% MwSt</span>
                        <span className="font-mono">{lohnanteilMwst.toFixed(2)} €</span>
                      </div>
                      <div className="flex justify-between font-semibold">
                        <span>Gesamt-Lohnsumme</span>
                        <span className="font-mono">{lohnanteilBrutto.toFixed(2)} €</span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </td>
            <td></td>
          </tr>
          )}
        </tbody>
      </table>
      {/* Mobile Totals */}
      <div className="lg:hidden">
        <div className="flex justify-end">
          <div className="w-full sm:w-72 space-y-2">
            {/* Mobile Gewerk-Zusammenstellung */}
            {hasTitels && titelGroups.length > 0 && (
              <div className="mb-3 pb-2 border-b">
                <p className="text-xs font-bold text-primary mb-2">Gewerk-/Titelzusammenstellung</p>
                {titelGroups.map((g, i) => (
                  <div key={`mtg-${i}`} className="flex justify-between py-1 text-sm">
                    <span>{g.nr && <span className="font-semibold mr-1">{g.nr}</span>}{displayTitel(g.titel)}</span>
                    <span className="font-mono">{g.sum.toFixed(2)} €</span>
                  </div>
                ))}
              </div>
            )}
            <div className="flex justify-between py-2">
              <span className="text-muted-foreground">Nettosumme</span>
              <span className="font-mono">{subtotal.toFixed(2)} €</span>
            </div>
            <div className="flex justify-between py-2 items-center">
              <div className="flex items-center gap-1">
                <span className="text-muted-foreground text-sm">Abschlag</span>
                <input type="number" step="0.1" value={discount || ""}
                  onChange={(e) => setDiscount(parseFloat(e.target.value) || 0)}
                  placeholder="0"
                  className="w-12 h-6 text-xs border rounded px-1 bg-white text-right font-mono" />
                <span className="text-xs text-muted-foreground">%</span>
              </div>
              <span className="font-mono">{discountAmt > 0 ? `-${discountAmt.toFixed(2)} €` : "0,00 €"}</span>
            </div>
            {discount > 0 && (
              <div className="flex justify-between py-2 border-t font-medium">
                <span>Nettobetrag</span>
                <span className="font-mono">{netAfterDiscount.toFixed(2)} €</span>
              </div>
            )}
            <div className="flex justify-between py-2 items-center">
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground">MwSt</span>
                <select value={vatRate} onChange={(e) => setVatRate(parseFloat(e.target.value))}
                  className="h-7 text-xs border rounded px-1 bg-white">
                  <option value={19}>19%</option>
                  <option value={7}>7%</option>
                  <option value={0}>0%</option>
                </select>
              </div>
              <span className="font-mono">{vat.toFixed(2)} €</span>
            </div>
            <div className="flex justify-between py-3 border-t-2 border-primary font-bold text-lg">
              <span>Brutto</span>
              <span className="font-mono">{total.toFixed(2)} €</span>
            </div>
            {type === "order" && (
              <div className="flex justify-between py-2 items-center">
                <span className="text-muted-foreground">Anzahlung</span>
                <div className="flex items-center">
                  <button type="button" onClick={() => setDepositAmount(Math.round(total * 30) / 100)}
                    className="mr-2 whitespace-nowrap text-[10px] px-1.5 py-0.5 border rounded text-muted-foreground">30 %</button>
                  <input type="number" step="0.01" min="0" value={depositAmount ?? ""}
                    onChange={(e) => setDepositAmount(parseFloat(e.target.value) || 0)}
                    className="w-20 border rounded px-2 py-1 text-sm text-right font-mono" />
                  <span className="ml-1">€</span>
                </div>
              </div>
            )}
            {type === "invoice" && (
              <>
                <div className="flex justify-between py-2 items-center">
                  <span className="text-muted-foreground">Anzahlung</span>
                  <div className="flex items-center">
                    <input type="number" step="0.01" value={depositAmount} readOnly={depositLocked}
                      onChange={(e) => setDepositAmount(parseFloat(e.target.value) || 0)}
                      className={`w-20 border rounded px-2 py-1 text-sm text-right font-mono ${depositLocked ? "bg-muted" : ""}`} />
                    <span className="ml-1">€</span>
                  </div>
                </div>
                {setDueDays && (
                  <div className="flex justify-between py-2 items-center">
                    <span className="text-muted-foreground">
                      Zahlungsziel{dueDateLabel ? <span className="block text-[10px]">bis {dueDateLabel}</span> : null}
                    </span>
                    <div className="flex items-center">
                      <input type="number" min="0" step="1"
                        value={dueDays ?? ""}
                        onChange={(e) => setDueDays(e.target.value === "" ? null : Math.max(0, parseInt(e.target.value, 10) || 0))}
                        className="w-16 border rounded px-2 py-1 text-sm text-right font-mono"
                        data-testid="input-invoice-due-days-mobile" />
                      <span className="ml-1">Tage</span>
                    </div>
                  </div>
                )}
                {depositAmount > 0 && (
                  <div className="flex justify-between py-2 text-primary font-semibold">
                    <span>Restbetrag</span>
                    <span className="font-mono">{finalAmount.toFixed(2)} €</span>
                  </div>
                )}
              </>
            )}
            {/* Lohnanteil Mobile (nur Rechnung) */}
            {type === "invoice" && (
            <div className="border-t pt-3 mt-3">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium">Lohnanteil</span>
                <button type="button" onClick={() => setShowLohnanteil(!showLohnanteil)}
                  className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${showLohnanteil ? "bg-green-100 text-green-700" : "bg-muted text-muted-foreground"}`}>
                  {showLohnanteil ? "Wird ausgewiesen" : "Nicht ausweisen"}
                </button>
              </div>
              <div className="space-y-1 text-sm">
                <div className="flex justify-between items-center">
                  <span className="text-muted-foreground">Lohnanteil (netto)</span>
                  <div className="flex items-center gap-1">
                    <input type="number" step="0.01" value={lohnanteilCustom}
                      onChange={(e) => setLohnanteilCustom(e.target.value)}
                      placeholder={totalLaborCost > 0 ? `Automatik ${Number(totalLaborCost).toFixed(2)}` : "0.00"}
                      className="w-28 border rounded px-2 py-1 text-right font-mono text-sm" data-testid="input-lohnanteil-mobil" />
                    <span className="text-muted-foreground">€</span>
                  </div>
                </div>
                {effectiveLohnanteil > 0 && (
                  <>
                    <div className="flex justify-between text-muted-foreground">
                      <span>zzgl. {vatRate}% MwSt</span>
                      <span className="font-mono">{lohnanteilMwst.toFixed(2)} €</span>
                    </div>
                    <div className="flex justify-between font-semibold">
                      <span>Gesamt-Lohnsumme</span>
                      <span className="font-mono">{lohnanteilBrutto.toFixed(2)} €</span>
                    </div>
                  </>
                )}
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { TotalsSection };
